import { Box, Button, Grid, Typography } from '@mui/material';
import { OrgAuthConfigPublicFragment } from '../lib/verid-api/verid-api-types';
import { useState } from 'react';
import { OrgSignUp } from './OrgSignUp';
import { ApolloClient } from '@apollo/client';
import { OrgLogin } from './OrgLogin';

interface IProps {
  authConfig: OrgAuthConfigPublicFragment;
  orgId: string;
  theme: any;
  onSigninSuccess?: () => void;
}

export function OrgSignUpOrSignIn({ authConfig, theme, orgId, onSigninSuccess }: IProps) {
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [showSignUp, setShowSignUp] = useState<boolean>(false);
  const spacing = theme.spacing(2);

  const cssClasses = {
    header: {
      width: '100%',
      left: 0,
      right: 0,
      letterSpacing: 0,
    },
    container: {
      maxWidth: '90vw',
      padding: '24px',
      [theme?.breakpoints.up('sm')]: {
        marginTop: '48px',
        width: '380px',
      },
    },
    title: {
      fontWeight: 'bold',
      fontSize: '1.5rem',
    },
    containerBtn: {
      width: '100%',
      marginBottom: spacing,
    },
    btnPrimary: {
      padding: `16px 8px`,
    },
  };
  if (showSignUp) {
    return (
      <OrgSignUp
        theme={theme}
        authConfigId={authConfig.id}
        orgId={orgId}
        onClickSignUpRedirect={() => {
          setShowSignUp(false);
          setShowLogin(true);
        }}
      />
    );
  }
  if (showLogin) {
    return (
      <OrgLogin
        theme={theme}
        authConfigId={authConfig.id}
        orgId={orgId}
        onClickSignUpRedirect={() => {
          setShowSignUp(true);
          setShowLogin(false);
        }}
        onSignInSuccess={() => {
          if (onSigninSuccess) {
            onSigninSuccess();
          }
        }}
      />
    );
  }
  return (
    <>
      <Typography align="left">Create an account or sign in to continue</Typography>
      <Grid container flexDirection="column" alignItems="center">
        <Box my={1} sx={cssClasses.containerBtn}>
          <Button
            sx={cssClasses.btnPrimary}
            variant="contained"
            fullWidth={true}
            color="primary"
            onClick={() => {
              setShowSignUp(true);
            }}
          >
            Create an account
          </Button>
        </Box>
      </Grid>

      <Grid container flexDirection="column" alignItems="center">
        <Box my={1} sx={cssClasses.containerBtn}>
          <Button
            sx={cssClasses.btnPrimary}
            variant="contained"
            fullWidth={true}
            color="primary"
            onClick={() => {
              setShowLogin(true);
            }}
          >
            Sign In
          </Button>
        </Box>
      </Grid>
    </>
  );
}
